@if (eventPage?.data?.length>0) {
  <div class="text-sm text-center lg:text-right">
    <div class=" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:mx-2 lg:mx-4 gap-8">
      <ng-container >
        @for (event of eventPage.data; track event) {
          <app-eventcard
          [event]="event" [hyperlink]="'/ocorrencia/' + event.slug"></app-eventcard>
        }
      </ng-container>
    </div>
    <div class="mt-16">
      <app-paginator [paginationDetails]="eventPage?.pageInfo" (pageChangeEvent)="onPageChange($event)"></app-paginator>
    </div>
  </div>
} @else {
  <div class="flex justify-center items-center h-1/2">
    <div class="w-2/3 text-center space-y-5">
      <p class="text-4xl"><i class="pi pi-search" style="font-size: 3.5rem"></i></p>
      <p>
        Não encontramos resultados com os filtros aplicados. Recomendamos que revise e ajuste os filtros para melhorar a precisão da busca.
      </p>
    </div>
  </div>
}
